import script from "./ReferraInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferraInfo.vue?vue&type=script&setup=true&lang=js"

import "./ReferraInfo.vue?vue&type=style&index=0&id=8c37c162&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c37c162"]])

export default __exports__